import { useEffect } from 'react';
import { useAuthStore } from '../store/authStore';
import { storage } from '../utils/storage';

// Sync auth state from localStorage across tabs
export function useCrossTabAuthSync() {
  useEffect(() => {
    return storage.subscribe('auth-storage', (_key, newValue) => {
      if (newValue === null) {
        useAuthStore.getState().logout();
        return;
      }
      useAuthStore.persist.rehydrate();
    });
  }, []);
}
